// extracted by mini-css-extract-plugin
module.exports = {"banner":"RecruitBanner_banner__0sOLy","inner":"RecruitBanner_inner__8A2AQ","title":"RecruitBanner_title__GvPAp","description":"RecruitBanner_description__j3dNo"};